"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ballot = exports.BallotIdentifier = void 0;
var buffer_1 = require("buffer");
var Allocation_1 = require("./Allocation");
var Payout_1 = require("./Payout");
var Serialization_1 = require("../../Handlers/Serialization");
var BallotIdentifier;
(function (BallotIdentifier) {
    BallotIdentifier[BallotIdentifier["Allocation"] = 1] = "Allocation";
    BallotIdentifier[BallotIdentifier["Payout"] = 2] = "Payout";
})(BallotIdentifier = exports.BallotIdentifier || (exports.BallotIdentifier = {}));
var Ballot = /** @class */ (function () {
    function Ballot(data) {
        this.data = data;
        this.identifier = 0;
        if (data instanceof Allocation_1.Allocation)
            this.identifier = BallotIdentifier.Allocation;
        if (data instanceof Payout_1.Payout)
            this.identifier = BallotIdentifier.Payout;
    }
    Ballot.read = function (buffer, offset) {
        var data = undefined;
        var _a = Serialization_1.readVarInt(buffer, offset), identifier = _a.value, offset2 = _a.offset;
        switch (identifier) {
            case BallotIdentifier.Allocation:
                var _b = Allocation_1.Allocation.read(buffer, offset2), allocation = _b.allocation, offset_allocation = _b.offset;
                data = allocation;
                offset = offset_allocation;
                break;
            case BallotIdentifier.Payout:
                var _c = Payout_1.Payout.read(buffer, offset2), payout = _c.payout, offset_payout = _c.offset;
                data = payout;
                offset = offset_payout;
                break;
        }
        if (!data)
            throw new Error('Ballot cannot be read');
        return { data: new Ballot(data), offset: offset };
    };
    Ballot.fromHex = function (hex) {
        var buffer = buffer_1.Buffer.from(hex, 'hex');
        var data = Ballot.read(buffer, 0).data;
        return data;
    };
    Ballot.prototype.getData = function () {
        if (this.data)
            return this.data;
        throw new Error("data is not valid");
    };
    Ballot.prototype.getSize = function () {
        return Serialization_1.getSizeOfVarInt(this.identifier) + this.data.getSize();
    };
    Ballot.prototype.toJson = function () {
        return {
            identifier: this.identifier,
            data: this.data
        };
    };
    Ballot.prototype.write = function (buffer, offset) {
        offset = Serialization_1.writeVarInt(this.identifier, buffer, offset);
        offset = this.data.write(buffer, offset);
        return offset;
    };
    Ballot.prototype.serialize = function () {
        var size = this.getSize();
        var buffer = buffer_1.Buffer.alloc(size);
        this.write(buffer, 0);
        return buffer;
    };
    Ballot.prototype.toHex = function () {
        return this.serialize().toString('hex');
    };
    return Ballot;
}());
exports.Ballot = Ballot;
//# sourceMappingURL=Ballot.js.map